import { render } from "./TableLiberaPrazo.vue?vue&type=template&id=78dd8405"
import script from "./TableLiberaPrazo.vue?vue&type=script&lang=js"
export * from "./TableLiberaPrazo.vue?vue&type=script&lang=js"

import "./TableLiberaPrazo.vue?vue&type=style&index=0&id=78dd8405&lang=sass"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QInput,QIcon,QCard,QCardSection,QRadio,QSeparator,QTd,QBtn,QPagination});
